module.exports = __webpack_public_path__ + "b163c7a067c7decba6e7b1af658a8b34.png";